import { Helmet } from "react-helmet";
import community from "../assets/community.jpg"
// import HeroSection from "../components/HeroSection";
import graph from '../assets/graph alone.jpg';
import TeamCard from "../components/TeamCard";
import { FaCircle } from "react-icons/fa";
import Steps from "../components/Steps"
import values from "../assets/Core values.png"
import mission from "../assets/3hmission.png"

function AboutUs() {

   const steps = [
      { title: "Talent Discovery", description: "We identify and nurture young talents across communities." },
      { title: "Skills Development", description: "Through training, mentorship, and education programs, participants gain practical and market-relevant skills." },
      { title: "Community Impact", description: "Participants apply their skills to solve local problems and create economic opportunities." },
      { title: "Sustainable Prosperity", description: "Our initiatives contribute to stronger economies, resilient communities, and ethical leadership." }
   ];

   const sdg = [
      "Quality Education",
      "Gender Equality",
      "Decent Work and Economic Growth",
      "Climate Action",
      "Peace, Justice and Strong Institutions"
   ]
   const header = {
      title: "About Us",
      subtitle: "Who We Are",
      imageAlt: "About us image",

   };

   const team = [
      {
         name: "Jane Doe",
         title: "CEO & Founder",
         quote: "Building solutions that truly make a difference.",
         image: "https://i.pravatar.cc/150?img=1",
      },
      {
         name: "John Smith",
         title: "Lead Developer",
         quote: "Code is poetry when done right.",
         image: "https://i.pravatar.cc/150?img=2",
      },
      {
         name: "Sarah Johnson",
         title: "Product Designer",
         quote: "Design is how it works, not just how it looks.",
         image: "https://i.pravatar.cc/150?img=3",
      },
      {
         name: "David Lee",
         title: "Marketing Lead",
         quote: "Great products deserve great storytelling.",
         image: "https://i.pravatar.cc/150?img=4",
      },
   ];

   const vissions = [
      {
         title: "Discovery",
         description: "Helping individuals identify their natural talents and potential."
      },
      {
         title: "Development",
         description: "Transforming those talents into practical skills through learning, training, and mentorship."
      },
      {
         title: "Deployment",
         description: "Empowering individuals to apply their skills to solve real societal challenges and contribute to national development."
      }
   ];

   const focuses = [
      "Youth-Driven Socio-Economic Development",
      "Gender Equality and Women’s Transformative Leadership",
      "Human Rights Advocacy and Democratic Institutions",
      "Poverty Eradication and Economic Justice",
      "Climate Resilience and Environmental Stewardship",
      "Leadership and Governance Development",
   ]

   return (
      <>
         <Helmet>
            <title>About OGTH – Empowering Africa's Youth & Women</title>
            <meta
               name="description"
               content="Learn about OGTH, a non-governmental organization dedicated to discovering, developing, and deploying the talents of Africa's youth and women across communities."
            />
            <meta
               name="keywords"
               content="OGTH, about OGTH, Africa youth programs, women empowerment, talent development, human capital"
            />
            <meta property="og:title" content="About OGTH – Empowering Africa's Youth & Women" />
            <meta property="og:description" content="Learn about OGTH, a non-governmental organization dedicated to discovering, developing, and deploying the talents of Africa's youth and women across communities." />
            <meta property="og:image" content="https://yourdomain.com/path-to-about-image.jpg" />
            <meta property="og:url" content="https://yourdomain.com/about" />
            <meta name="twitter:card" content="summary_large_image" />
         </Helmet>

         {/* The about us hero section */}
         <div className="bg-gradient-to-b from-brand to-[#1A3A6F] text-white">
            <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
               {/* Left side - Text */}
               <div className="space-y-6">
                  <h1 className="text-3xl font-bold">{header.title}</h1>
                  <p className="font-bold text-gray-300">{header.subtitle}</p>

                  <p className="text-justify">
                     The Organization for Global Talents Hunt (OGTH) is a non-governmental organization that is registered with Corporate Affairs Commission in Abuja, Nigeria and operating under the Project Africa framework. Headquartered in Nigeria, OGTH works across African countries to promote human capital development and sustainable prosperity.
                     <br /><br />
                     Our work focuses on harnessing Africa's greatest asset its youthful population by investing in young people to discover, develop, and deploy their talents. Through innovative programs and initiatives, we aim to increase Africa’s Human Capital Index and empower individuals to solve local challenges while contributing to national and continental development.
                  </p>

               </div>
               {/* Right side - Image */}
               <div className="flex justify-center md:justify-end">
                  <img
                     src={community} // Replace with image path
                     alt={header.imageAlt}
                     className="w-full max-w-lg rounded-lg shadow-lg"
                  />
               </div>
            </div>
         </div>
         {/* End of about us hero section */}

         {/* AHC setion begins here */}
         <section className="bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
               {/* Left side - list*/}
               <div>
                  <ul className="space-y-4 max-w-md my-5">
                     {focuses.map((focus, index) => (
                        <li
                           key={index}
                           className="flex items-center gap-3 bg-brand-secondary text-white rounded-lg px-4 py-3 shadow-sm hover:shadow-md hover:-translate-y-1 transition"
                        >
                           {/* Circle */}
                           <span className="flex items-center justify-center w-6 h-6 rounded-full border-2 border-white">
                              <FaCircle className="text-[6px] text-white" />
                           </span>

                           {/* Text */}
                           <span className="text-sm font-medium">
                              {focus}
                           </span>
                        </li>
                     ))}
                  </ul>
               </div>

               {/* Right side - text */}
               <div className="justify-center md:justify-end space-y-6">
                  <h1 className="text-center text-xl font-bold">AHC Vision 2050 </h1>
                  <p className="font-bold text-brand-greenText text-center">
                     Africa Human Capital Vision 2050 Initiative
                  </p>
                  <p className="text-justify">
                     The Africa Human Capital Vision 2050 Initiative (AHC Vision 2050) is a long-term roadmap designed to strengthen human capital across African nations by the year 2050.
                  </p>
                  <p className="text-justify">
                     With over 60% of Africa’s population under the age of 25, investing in education, skills, leadership, and innovation is critical for sustainable economic growth. The initiative seeks to empower individuals with knowledge, skills, and opportunities that enable them to become productive contributors to their societies.
                  </p>
               </div>
            </div>
         </section>
         {/* AHC section ends here */}

         {/* Vission section starts here */}
         <section className="bg-brand">

            <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

               {/* Left side - text */}

               <div className="space-y-6">
                  <div className="text-center space-y-6">
                     <h1 className="text-xl text-white font-bold">Our Vision</h1>
                     <p className="font-bold text-gray-300 italic">
                        "To Invest in human capital development as change agents to drive systemic sustainable economic prosperity."
                     </p>
                  </div>
                  <div className="text-justify text-white">
                     <p className="pb-3">
                        Our objective is to discover hidden talents, develop them into practical skills, and deploy them as solution providers addressing Africa's most pressing challenges.
                        Through structured programs and innovative platforms, we equip individuals with the tools to build better communities and stronger economies.
                     </p>
                     <p>
                        Embodied in the Latin maxim, <span className="italic font-bold">“Aut viam inveniam aut faciam”</span>, which translates to, <span className="italic font-bold">‘I find the way, or I will make one”.</span>
                     </p>
                  </div>
               </div>

               {/* Right side - Cards */}
               <div className="bg-gray-50 rounded-lg shadow-xl">
                  <Steps steps={vissions}></Steps>
               </div>
            </div>
         </section>
         {/* vission section ends here */}

         {/* Mision setion begins here */}
         <section className="bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

               {/* Left side - image */}
               <div className="space-y-6 r">
                  <h1 className="text-center text-xl font-bold">Mission</h1>
                  <p className="font-medium text-brand-greenText italic text-center">
                     "To create platforms and Structures to run programmes and projects capable of increasing the Human Capital Index."
                  </p>

                  <div className="text-justify ml-3">
                     <p className="pb-3">
                        At OGTH, we believe every person has unique abilities waiting to be discovered. Through supportive environments and structured programs, we help individuals build confidence, develop skills, and transform potential into real impact.
                     </p>
                     <p>
                        By providing supportive environments, tailored programs, and positive values, we empower every child to uncover and cultivate their gifts. This conviction guides our project conceptualization and design, and we take pride in transforming potential into performance and ensuring that no talent goes untapped in the pursuit of personal fulfillment and societal advancement.
                     </p>
                  </div>
               </div>

               {/* Right side - text */}
               <div className="flex justify-center md:justify-end">
                  <img
                     src={graph} // Replace with image path
                     alt="Mission Illustration"
                     className="w-full max-w-lg rounded-lg shadow-lg"
                  />
               </div>
            </div>
         </section>
         {/* Mission section ends here */}

         {/* Our Approach section starts here */}
         <section className="bg-brand">
            <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

               {/* Left side - Image */}
               <div className="flex justify-center">
                  <img
                     src={mission}
                     alt="Hero Illustration"
                     className="w-full h-auto object-contain rounded-lg shadow-lg"
                  />
               </div>

               {/* Right side - Text */}
               <div className="space-y-6 text-center">
                  <h1 className="text-xl text-white font-bold">Our Approach</h1>
                  <p className="font-medium italic text-gray-300">
                     Our programs are grounded in the 3H framework, which focuses on developing the whole person.
                  </p>
                  <p className="text-justify text-white">
                     In line with our mission, OGTH focuses on creating structured programs and supportive platforms that help people build self confidence and uncover innate abilities. We express giftedness through our 3H framework:
                  </p>
                  <ul className="text-justify text-white space-y-3">
                     <li><span className="font-bold">Head</span > <span className="font-medium">(Cognitive Domain)</span>: Critical thinking and rational mind</li>
                     <li><span className="font-bold">Heart</span> <span className="font-medium">(Affective Domain)</span>: Compassion, Values, and Impeccable Character </li>
                     <li><span className="font-bold">Hand</span> <span className="font-medium">(Psychomotor Domain)</span>: Craftsmanship and skillfulness  </li>
                  </ul>
               </div>
            </div>
         </section>
         {/* Our Approach section ends here */}


         {/* Our core values section begins here */}
         <section className="bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

               {/* Left side - image */}
               <div className="flex justify-center md:justify-end">
                  <img
                     src={values}
                     alt="values Illustration"
                     className="w-full h-auto object-contain rounded-lg shadow-lg"
                  />
               </div>

               {/* Right side - text */}
               <div className="space-y-6 r">
                  <h1 className="text-center text-xl font-bold">Our Core Values</h1>
                  <p className="font-bold text-brand-greenText text-center italic">
                     Discipline, Honour, Foresight, and Leadership
                  </p>
                  <p className="text-justify">
                     OGTH is also committed to the principles of equity, fairness and justice, OGTH’s core values guide every program and platform while ensuring equal recognition for all talents.
                  </p>
                  <p className="text-justify">
                     Empowering youths and women to become vissionary leaders and agents of change in their society. The OGTH Core-Values are summarized by four concepts, Discipline, Honour, Foresight and Leadership.
                  </p>
               </div>
            </div>
         </section>
         {/* Core values section ends here */}

         {/* SDG section */}
         <section className="bg-gray-50 py-10">
            <h1 className="text-lg font-bold text-center">Contributing to the Sustainable Development Goals</h1>
            <p className="p-2 text-center">OGTH aligns its initiatives with the United Nations Sustainable Development Goals (SDGs) to ensure sustainable and inclusive development.</p>

            <div>
               <Steps steps={steps}></Steps>
            </div>
            <h1 className="text-center font-bold">Key SDGs supported:</h1>

            {/* unordered list */}
            <ul className="space-y-4 max-w-md my-5 mx-auto px-5">
               {sdg.map((sd, index) => (
                  <li
                     key={index}
                     className="flex items-center gap-3 bg-brand-secondary text-white rounded-lg px-4 py-3 shadow-sm hover:shadow-md hover:-translate-y-1 transition"
                  >
                     {/* Circle */}
                     <span className="flex items-center justify-center w-6 h-6 rounded-full border-2 border-white">
                        <FaCircle className="text-[6px] text-white" />
                     </span>

                     {/* Text */}
                     <span className="font-medium">
                        {sd}
                     </span>
                  </li>
               ))}
            </ul>

         </section>
         {/* SDG section ends here */}


         {/* team members section */}
         {/* <section className="py-10 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6">
               <h2 className="text-lg font-bold font-bold text-center">
                  Meet Our Team
               </h2>
               <h3 className="text-center font-bold text-brand-greenText my-2 mb-5">Board of trustees</h3>
               <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                  {team.map((member, index) => (
                     <TeamCard key={index} {...member} />
                  ))}
               </div>
            </div>
         </section> */}
         {/* team members section ends */}


      </>
   )
}

export default AboutUs;